import React, { useEffect, useState } from "react";
import InnerLayout from "../../components/layouts/inner-layout";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import LoadingSpinner from "../../components/helper-components/loading-spinner";
import { productViewAction } from "../../redux/actions/product-action";
import ViewEditProduct from "../../components/product-information/product-view-edit";
const EditProduct = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState({});
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    dispatch(productViewAction(id, onSuccess, onError));
  }, []);
  const onSuccess = (data) => {
    setLoading(false);
    setProduct(data?.data?.[0]);
  };
  const onError = (data) => {
    loading(false);
  };
  return (
    <>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <InnerLayout
          backBtn={true}
          title="Edit Product"
          // title1={product?.item_code}
          view={true}
          onclkEditFn={() => navigate(`/edit-product/${id}`)}
        >
          <ViewEditProduct product={product} page="edit" />
        </InnerLayout>
      )}
    </>
  );
};

export default EditProduct;
